import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showError } from 'redux/modules/notification';
import { Dispatch } from 'redux/types';

export interface UseSocialShareAuthConfig {
  onAuthSuccess: () => void;
}

export interface UseSocialShareAuthResult {
  onAuthSuccess: () => void;
  onAuthError: (error: Error | string) => void;
}

export default function useSocialShareAuth({
  onAuthSuccess,
}: UseSocialShareAuthConfig): UseSocialShareAuthResult {
  const dispatch = useDispatch<Dispatch>();

  const handleAuthSuccess = useCallback(() => {
    onAuthSuccess();
  }, [onAuthSuccess]);

  const handleAuthError = useCallback(
    (error: Error | string) => {
      dispatch(showError(typeof error === 'string' ? error : error.message, 5));
    },
    [dispatch],
  );

  return {
    onAuthSuccess: handleAuthSuccess,
    onAuthError: handleAuthError,
  };
}
